import { LanguageMetadata, TestMetadata } from 'api/API';
import { DraftStatus } from './SetResponses';

export enum DeviceStatus {
  DRAFT = 'part.draft',
  PENDING = 'part.pending',
}

/* Transform status to valid status tile input */
export const deviceStatus: Record<DeviceStatus, DraftStatus> = {
  'part.draft': DraftStatus.DRAFT,
  'part.pending': DraftStatus.PENDING,
};

export interface DeviceResponse {
  inspection_manual?: File;
  id: string;
  user: string;
  owner_email: string;
  status: DeviceStatus;
  image: string;
  description: string;
  cannulated: boolean;
  comments: string[];
  num_parts: string;
  disassembly_info: string | null;
  inspection_text: string | null;
  inspection_text_description?: string;
  language_metadata: LanguageMetadata | null;
  test_metadata: TestMetadata | null;
  prone_to_debris?: boolean;
  draft_exists?: boolean;
  owned_by?: string;
  tenant?: string;
}
